import React from "react";

const members = [
  {
    name: "Freskim",
    role: "Inxhinier kryesor",
    bio: "Arkitekturë, qëndrueshmëri platforme dhe udhëheqje teknike në angazhime full-stack.",
    initials: "F",
    accent: "linear-gradient(135deg, #22d3ee 0%, #6366f1 100%)",
  },
  {
    name: "Lulzim",
    role: "Dizajner kryesor produkti",
    bio: "Sisteme dizajni, kërkim UX dhe punëtori me palët e interesuara nga zbulimi deri në QA.",
    initials: "L",
    accent: "linear-gradient(135deg, #a78bfa 0%, #22d3ee 100%)",
  },
  {
    name: "Blerim",
    role: "Inxhinier senior mobile",
    bio: "Dorëzim iOS dhe Android, përputhje me dyqanet dhe optimizim performance për aplikacione masive.",
    initials: "B",
    accent: "linear-gradient(135deg, #34d399 0%, #22d3ee 100%)",
  },
];

function Team() {
  return (
    <section className="team section-pad" id="team">
      <div className="container">
        <div className="section-heading">
          <span className="section-tag">Udhëheqja</span>
          <h2>Profesionistë seniorë në çdo angazhim</h2>
          <p>
            Punoni drejtpërdrejt me udhëheqës me përvojë — pa zëvendësim me
            ekipe vetëm junior. Scale-up-et dhe ndërmarrjet na angazhojnë kur
            risku i dorëzimit duhet të mbetet i ulët.
          </p>
        </div>

        <div className="team-grid">
          {members.map(({ name, role, bio, initials, accent }) => (
            <article key={name} className="member">
              <div
                className="member-avatar"
                style={{ background: accent }}
                aria-hidden="true"
              >
                <span className="member-initials">{initials}</span>
              </div>
              <h3>{name}</h3>
              <p className="member-role">{role}</p>
              <p className="member-bio">{bio}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Team;
